module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog-panel",
    class: _vm.clazz
  }, [_c('dialog-element', {
    ref: "dialog",
    attrs: {
      "params": {
        native: _vm.native,
        style: _vm.style,
        width: _vm.width,
        height: _vm.height
      }
    }
  }, [(_vm.needClose) ? _c('div', {
    staticClass: "close rotate sm-close",
    on: {
      "click": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-wrapper",
    class: {
      'pad-bottom': _vm.needFooter
    }
  }, [(_vm.title || _vm.$slots.title) ? _c('div', {
    staticClass: "header"
  }, [_vm._t("title", [_c('div', {
    attrs: {
      "show": _vm.title
    },
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })])], true) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("content", [(_vm.comps[_vm.contentView]) ? _c(_vm.contentView, {
    ref: "view",
    tag: "component",
    attrs: {
      "params": _vm.data
    }
  }) : _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" ")])], true), _vm._v(" "), (_vm.needFooter) ? _c('div', {
    staticClass: "footer"
  }, [_vm._t("footer", [_c('div', {
    staticClass: "default-bottom"
  }, [_c('button', {
    staticClass: "button ensure-button",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v(_vm._s(_vm.ensureText))]), _vm._v(" "), (_vm.needCancel) ? _c('button', {
    staticClass: "button cancel-button",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]) : _vm._e()])])], true) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-dafcf21e!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./source/DialogPanel/DialogPanel.vue
// module id = 161
// module chunks = 1 3 4